import React, { Component } from 'react';
import ReactPlaceholder from 'react-placeholder';
import { InputPlaceholder } from '@contently/toolkit';
import { get } from '../../utils/api';
import EnhancedSelect from './enhanced_select/enhanced_select';
import formatOptions from '../../utils/formatters/formatOptions';
import { handleError } from '../../utils/errors';

class CampaignSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaigns: []
    };
  }

  componentDidMount() {
    const { brandProfileId, onFetching, onError } = this.props;
    onFetching('campaigns', true);
    return get(`/api/v1/brand_profiles/${brandProfileId}/campaigns`)
      .then(res => {
        onFetching('campaigns', false);
        this.setState({
          campaigns: res
        });
      })
      .catch(error => {
        handleError(error, () => onError());
      });
  }

  render() {
    const { campaigns } = this.state;
    const { fetching, values, errors, touched } = this.props;
    return (
      <ReactPlaceholder
        showLoadingAnimation
        customPlaceholder={<InputPlaceholder wrapperClass="row" withLabel />}
        ready={!fetching}
      >
        <EnhancedSelect
          {...this.props}
          id="campaigns"
          selectedValue={values.campaigns}
          options={formatOptions(campaigns)}
          errors={errors.campaigns}
          touched={touched.campaigns}
          label="Campaigns"
          placeholder="Select campaigns"
          noTranslate
          multi
        />
      </ReactPlaceholder>
    );
  }
}

export default CampaignSelect;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/campaign_select.jsx